import React, { Component } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import AnimateHeight from 'react-animate-height'

import Typography from '../../UniformComponents/Typography'
import Checkbox from '../form/Checkbox'

import '../TemplateAccess/template-access.scss'

@observer
class EmailTemplateRespondents extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isAccOpen: {},
        }
    }

    toggleIndustry = (i) => {
        this.setState((prevState) => ({
            isAccOpen: {
                ...prevState.isAccOpen,
                [i]: !prevState.isAccOpen[i],
            },
        }))
    }

    renderCheckbox = (f, oid) => {
        const { toggleRespondentsCheckbox, updating, respondentCheckboxOptions } = this.props.templateSearchStore
        let field = f
        if (!field) return
        if (typeof field === 'string') {
            field = respondentCheckboxOptions[field]
        }
        return (
            <div className="form-checkbox-wrapper">
                {[2, 6, 7].includes(oid) && <span>{i18n.t('gen_select_all')}</span>}
                <Checkbox
                    onBlur={(obj, e) => toggleRespondentsCheckbox(obj, e, field, oid)}
                    name={field.label}
                    checked={field.checked}
                    valueid={field.id}
                    disabled={updating}
                    stopPropagation
                />
            </div>
        )
    }

    render() {
        const { fieldConfig, templateSearchStore } = this.props
        const { isAccOpen } = this.state
        const {
            respondentLabel,
            respondentCheckboxOptions,
            hasRespondentRequiredError,
        } = templateSearchStore
        const cn = `check-acc-wrapper ${hasRespondentRequiredError ? 'required-error' : ''}`
        return (
            <div className={cn} style={fieldConfig?.style || null}>
                <div className="check-acc">
                    <div className="check-acc-header">
                        <i className="header-icon fa-solid fa-circle-info" />
                        <p className="header-label">{respondentLabel}</p>
                    </div>
                    <div className="check-acc-body">
                        <hr className="acc-divider" />
                        <div className="option-list">
                            {Object.keys(respondentCheckboxOptions).map((ind, idx) => (ind !== 'all'
                                ? (
                                    <div className="option" key={`${ind}_${idx}`}>
                                        {/* Industries */}
                                        <div
                                            className="option-heading"
                                            onClick={() => { this.toggleIndustry(ind) }}
                                        >
                                            <i className={`option-icon fa-regular ${isAccOpen[ind]
                                                ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                            />
                                            <p className="option-name">
                                                {respondentCheckboxOptions[ind].label}
                                            </p>
                                            {this.renderCheckbox(ind, 2)}
                                        </div>
                                        <AnimateHeight
                                            className="option-acc"
                                            duration={250}
                                            height={isAccOpen[ind] ? 'auto' : 0}
                                        >
                                            <hr className="option-divider" />
                                            <div className="checks">
                                                {/* Product Types */}
                                                {ind !== 'all' && respondentCheckboxOptions[ind].productTypes.map((p, pIndex) => (
                                                    <div className="option" key={`${p.id}_${pIndex}`}>
                                                        <div
                                                            className="option-heading"
                                                            onClick={() => { this.toggleIndustry(`${ind}-${p.id}-${pIndex}`) }}
                                                        >
                                                            <i className={`option-icon fa-regular ${isAccOpen[`${ind}-${p.id}-${pIndex}`]
                                                                ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                                            />
                                                            <p className="option-name">
                                                                {p.label}
                                                            </p>
                                                            {this.renderCheckbox(p, 6)}
                                                        </div>

                                                        <AnimateHeight
                                                            className="option-acc"
                                                            duration={250}
                                                            height={isAccOpen[`${ind}-${p.id}-${pIndex}`] ? 'auto' : 0}
                                                        >
                                                            <hr className="option-divider" />
                                                            <div className="checks">
                                                                {/* Survey Types */}
                                                                {ind !== 'all' && p.surveyTypes.map((s, sIndex) => (
                                                                    <div className="option" key={`${s.id}_${sIndex}`}>
                                                                        <div
                                                                            className="option-heading"
                                                                            onClick={() => { this.toggleIndustry(`${p.id}-${s.id}-${sIndex}`) }}
                                                                        >
                                                                            <i className={`option-icon fa-regular ${isAccOpen[`${p.id}-${s.id}-${sIndex}`]
                                                                                ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                                                            />
                                                                            <p className="option-name">
                                                                                {s.label}
                                                                            </p>
                                                                            {this.renderCheckbox(s, 7)}
                                                                        </div>
                                                                        <AnimateHeight
                                                                            className="option-acc"
                                                                            duration={250}
                                                                            height={isAccOpen[`${p.id}-${s.id}-${sIndex}`] ? 'auto' : 0}
                                                                            >
                                                                            <hr className="option-divider" />
                                                                            <div className="checks">
                                                                            {ind !== 'all' && s.respondentTypes.map((r, rIndex) => (
                                                                                <div key={`${r.id}_${rIndex}`} className="check-item">
                                                                                    <span>{r.label}</span>
                                                                                    {this.renderCheckbox(r, 12)}
                                                                                </div>
                                                                            ))}
                                                                            </div>
                                                                        </AnimateHeight>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </AnimateHeight>
                                                    </div>
                                                ))}
                                            </div>
                                        </AnimateHeight>
                                    </div>
                                ) : null))}
                        </div>
                    </div>
                </div>
                {hasRespondentRequiredError
                    ? (
                        <div className="error-container">
                            <Typography type="p" color="error">
                                {i18n.t('gen_select_one')}
                            </Typography>
                        </div>
                    ) : null}
            </div>
        )
    }
}

export default EmailTemplateRespondents
